const ethIcon = ()=>{
  return (
	 <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 417" width="32" height="32">
  <g fill="#627EEA">
    <path d="M127.68 0L124 11.33v273.53l3.68 3.68 127.68-72.82zM127.68 0L0 215.72l127.68 72.82V0zM127.68 301.68l-2.08 2.53v108.4l2.08 4.76 127.79-179.76zM127.68 417v-113.8L0 233.13z"/>
  </g>
</svg>
  )
}
export default ethIcon; 

